export const CHATS_ONLINE_STATUS_REFRESH_INTERVAL = 5000;

// Number of minutes after which a user is considered offline
export const IDLE_ONLINE_TIME_MINUTES = 1;

export const CHAT_INBOX_FETCHER_THROTTLING_MS = 400;
